import styled, { css } from 'styled-components';
import { getColor, getColorShade, getSizeBy, getThemeProp } from '../../../../../src/styled/utils';
import { BorderLeft, BorderTop, BorderRight } from '../../../../../src/styled/shared-styles';
import { AppBarButton } from '../../../app-bar-button';
import { SETTINGS_WIDTH } from '../../style-constants';
const NeedOverfolw = css `
  overflow: auto;
`;
export const StyledControls = styled.div `
  display: grid;
  flex-grow: 0;
  flex-shrink: 0;
  grid-template: repeat(2, auto) / 1fr repeat(2, auto);
  grid-template-areas:
    'search search search'
    'actionstabs pagination settings'
    'topsubtitle topsubtitle topsubtitle';
  align-items: center;
  width: ${({ $withSettings }) => ($withSettings ? `calc(100% - ${SETTINGS_WIDTH})` : '100%')};
  background-color: ${getColor('surface')};
  border-top-left-radius: ${getThemeProp('borderRadius')}px;
  border-top-right-radius: ${getThemeProp('borderRadius')}px;
  transition: width 0.3s ease-out;
  will-change: width;
  ${BorderTop}
  ${BorderLeft}
  ${({ $withSettings }) => !$withSettings && BorderRight}
`;
export const SearchBlock = styled.div `
  grid-area: search;
`;
export const TabsBlock = styled.div `
  grid-area: tabs;
`;
export const ActionsTabsBlock = styled.div `
  display: flex;
  flex-direction: column;
  grid-area: actionstabs;
  ${({ $needOverflowTabs }) => $needOverflowTabs && NeedOverfolw};
`;
export const TopSubtitleBlock = styled.div `
  grid-area: topsubtitle;
`;
export const PaginationBlock = styled.div `
  grid-area: pagination;
`;
export const ActionButton = styled(AppBarButton) `
  width: ${getSizeBy(9)};
  height: ${getSizeBy(11)};
  visibility: ${({ $isVisible }) => ($isVisible ? 'visible' : 'hidden')};

  & svg {
    color: ${({ $sideBarType, $activeSidebar }) => {
    return $sideBarType === undefined
        ? getColorShade('onSurface', 'mediumEmphasis')
        : $sideBarType === $activeSidebar
            ? getColor('primary')
            : getColorShade('onSurface', 'mediumEmphasis');
}};
  }
`;
export const SettingsButton = styled(ActionButton) `
  grid-area: settings;
`;
